export const app = {
    'cashout': 'cash out',
    'deposit': 'Deposit',
    'watchLive': 'Watch Live',
    'watch': 'Watch',
    'new': 'New',
    'live': 'Live',
    'download': 'Download',
    'signIn': 'Log In',
    'lobby': 'Sports',
    'noEventsFound': 'No events found',
    'noEventsToShow': 'Currently there are no events to show',
    'errorMessage': 'An internal error occurred within the back end system. Contact Coral for more information.',
    'serverError': 'Server is unavailable at the moment, please try again later.',
    'errorServiceDepartmentMessage': 'If this problem persists, contact our ',
    'errorServiceDepartmentLink': 'Customer Service Department',
    'requestErrorMessage': 'Oops! We are having trouble loading this page. Please check your connection',
    'tryAgain': 'Try Again',
    'moreInfo': 'More Info',
    'accept': 'Accept',
    'phoneRotate': "Please rotate your screen back in Portrait Mode. Please ensure you have 'screen rotate' option active.",
    'acceptAndClose': 'Accept & close',
    'error': 'Error',
    '503_errorTitle': '503 Error - Services Unavailable',
    '503_errorMessage': 'Please contact your support team for assistance',
    '404_errorTitle': '404 Error - The page you are looking for no longer exists',
    '404_errorMessage': 'Perhaps you can return back to the site’s homepage and see if you can find what you are looking for',
    'errorPopupMessage': 'If this problem persists, contact our Customer Service Department',
    'errorPopupLink': 'Contact Customer Services',
    'monthsJan': 'Jan',
    'monthsFeb': 'Feb',
    'monthsMar': 'Mar',
    'monthsApr': 'Apr',
    'monthsMay': 'May',
    'monthsJun': 'Jun',
    'monthsJul': 'Jul',
    'monthsAug': 'Aug',
    'monthsSep': 'Sep',
    'monthsOct': 'Oct',
    'monthsNov': 'Nov',
    'monthsDec': 'Dec',
    'birthDate': 'Date of Birth',
    'birthDateDay': 'Day',
    'birthDateMonth': 'Month',
    'birthDateYear': 'Year',
    'invalidDate': 'Please enter valid date',
    'loginToSeePageMessage': 'Please log in to see your {page}.',
    'forYouPersonalisedMessage': 'Please log in to see personalised bets For You',
    'internetError': 'No internet connection',
    'connectionLostMessage':
        'You are currently experiencing issues connecting to the internet. ' + 'Please check your internet connection and try again.',
    'bonusSuppresion': 'Permission Denied',
    'betslipTabs': {
        betslip: 'Bet Slip',
        cashout: 'Cash Out',
        openbets: 'Open',
        betReceipt: 'Bet Receipt',
        toteBetReceipt: 'Tote Bet Receipt',
        betHistory: 'Settled',
        inShopBets: 'Shop Bets',
        settledbets: 'Settled',
        shopbets: 'Shop Bets',
        openMsg: 'Open Bets',
        settledMsg: 'Settled Bets',
        cashoutMsg: 'Cash Out Bets',
        betHistoryMsg: 'Settled Bets',
    },
    'updatedPolicy': 'Updated Policies',
    'change': 'Change',
    'market': 'Market:',
    'orderBy': 'ORDER BY:',
    'tooltip': {
        winAlerts: 'Turn on Win alerts and we will alert you when you win',
        editMyAcca: 'Now you can remove selections from your acca to keep your bet alive',
        oddsBoostUnavailable: 'Odds Boost is unavailable for this selection',
        secondaryMarketsTitle: `{moreMarketTooltip}`,
        lineupsTitle: `{lineups}`,
        eachWay: `{eachWayTooltip}`,
        fanzoneGames: `{message}`,
        restrictedHorseTooltip: `{restrictedHorseTooltipMessage}`,
        restrictedRaceCardTooltip: `{restrictedRaceCardTooltipMessage}`,
        myStableBookmark: `{myStableBookmarkTooltip}`,
    },
    'pendingVerificationDialogTitle': 'VERIFYING YOUR DETAILS',
    'bogLabel': 'Best Odds Guaranteed',
    'bogExtraEarnings': 'You won: ',
    'suspended': 'SUSP',
    'suspendedStatus': 'S',
    'placed': 'placed',
    'iDonotSupportAnyTeam': "I don't support any of these teams",
    'highLowerVal': 'HL',
    'ok': 'OK',
    'nwInterrrupted': 'Network Connection Interrupted',
};
